import React from 'react';
import { Icon } from './Icon.js';
export const IconCode3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M10.8184 18H8.68164L13.1816 6H15.3184L10.8184 18Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" }),
        React.createElement("path", { d: "M22.707 11.293L23.4141 12L17.251 18.1621L16.4805 16.1055L20.5859 12L16.6709 8.08496L17.4424 6.02734L22.707 11.293Z", fill: "currentColor", "data-stroke": "none" }),
        React.createElement("path", { d: "M7.1377 8.27539L3.41406 12L7.32812 15.9141L6.55664 17.9707L0.585938 12L6.36621 6.21875L7.1377 8.27539Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconCode3.js.map